import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getContainerFactoryStyles } from './styles/element-selector-styles';

class RawElementSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    const elementAvailableStatuses = React.Children.map(props.children, () => false);

    this.fallbackElementIndex = -1;

    this.state = {
      elementAvailableStatuses,
    };
  }

  updateAvailability = index => (
    (isAvailable) => {
      this.setState((prevState) => {
        if (prevState.elementAvailableStatuses[index] === isAvailable) {
          return null;
        }

        const elementAvailableStatuses = prevState.elementAvailableStatuses.slice();
        elementAvailableStatuses[index] = isAvailable;
        return { elementAvailableStatuses };
      }, () => { this.props.onSelectionChange(this.state.elementAvailableStatuses); });
    }
  );

  // At anytime only one element will be visible. And if there are multiple available elements,
  // only the one in front will be visible. Customized placeholder only shows when initializing
  // the container as fallback choice, after that will fallback to previous visible element.
  render() {
    let computedVisibleElementIndex = this.fallbackElementIndex;
    let hasAvailableElement = false;

    this.state.elementAvailableStatuses.forEach((isElementAvailable, index) => {
      if (hasAvailableElement) {
        return;
      }

      if (isElementAvailable) {
        this.fallbackElementIndex = index;
        hasAvailableElement = true;
        computedVisibleElementIndex = index;
      }
    });

    return (
      <React.Fragment>
        {
          React.Children.map(
            this.props.children,
            (child, index) => (
              <div
                className={
                  (computedVisibleElementIndex === index)
                    ? classNames([this.props.classes.visible, 'visible-element'])
                    : this.props.classes.hidden
                }
              >
                {child &&
                  React.cloneElement(
                    child,
                    {
                      updateAvailability: this.updateAvailability(index),
                      isVisible: computedVisibleElementIndex === index,
                    }
                  )
                }
              </div>
            )
          )
        }
        {this.fallbackElementIndex === -1 && this.props.fallback}
      </React.Fragment>
    );
  }
}

RawElementSelector.propTypes = {
  classes: PropTypes.shape(mapObject(
    getContainerFactoryStyles(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  fallback: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onSelectionChange: PropTypes.func,
};

RawElementSelector.defaultProps = {
  fallback: null,
  onSelectionChange: () => { },
};

export const ElementSelector = withDefaultStyles(RawElementSelector, getContainerFactoryStyles);
